import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalService } from 'src/app/apv/core/services/modal/modal.service';
import { bringModalToFront } from 'src/app/apv/core/utils/functions';
import {
  GENERATIONAL_FUNDS_MODAL_FAQS,
  GENERATIONAL_FUNDS_MODAL_TEXTS,
} from '../../constants/generational-funds-modal.constant';

@Component({
  selector: 'app-generational-funds-modal',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './generational-funds-modal.component.html',
  styleUrls: ['./generational-funds-modal.component.scss'],
  standalone: false,
})
export class GenerationalFundsModalComponent implements OnInit {
  readonly texts = GENERATIONAL_FUNDS_MODAL_TEXTS;
  readonly faqs = GENERATIONAL_FUNDS_MODAL_FAQS;

  openedIndex: number | null = null;

  constructor(
    private readonly modalSvc: ModalService,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    bringModalToFront(this.elementRef.nativeElement);
  }

  isOpen(index: number): boolean {
    return this.openedIndex === index;
  }

  toggle(index: number): void {
    this.openedIndex = this.isOpen(index) ? null : index;
  }

  closeModal(): void {
    this.modalSvc.closeModal();
  }
}
